import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, shareReplay, catchError, map } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface FeatureFlags {
  enableAdvancedContextFields: boolean;
}

const DEFAULT_FLAGS: FeatureFlags = {
  enableAdvancedContextFields: true,
};

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagsService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = environment.apiUrl;

  private flags$: Observable<FeatureFlags> | null = null;

  getFlags(): Observable<FeatureFlags> {
    if (!this.flags$) {
      this.flags$ = this.http
        .get<FeatureFlags>(`${this.apiUrl}/feature-flags`)
        .pipe(
          catchError(() => of(DEFAULT_FLAGS)),
          shareReplay(1),
        );
    }
    return this.flags$;
  }

  get enableAdvancedContextFields$(): Observable<boolean> {
    return this.getFlags().pipe(
      map((flags) => flags.enableAdvancedContextFields),
    );
  }
}
